export default "__VITE_ASSET__6c546790__"